import React, { useState } from 'react'
import Pagination from '../Components/Pagination';
import Snackbar from '../Components/Snackbar';
import { fetchData, PostData } from '../Services/httpHandelars'
import Loader from '../Components/Loader';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context'
const Notifications = () => {


  const [form, setForm] = useState({ startDate: "", endDate: "" })
  const [notifications, setNotification] = useState([])
  const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })
  // const navigate = useNavigate();
  const handlsePageChange = (body) => {

    if (form.startDate && form.endDate) {
      const data = {
        startDate: form.startDate,
        endDate: form.endDate,
        skip: body.skip,
        limit: 25

      }

      PostData("/api/getNotificationData", data)
        .then((data) => {

          if (data.status == true) {
            setSnacBar({
              ...snacBar,
              snacStatus: true,
              message: data.message,
              snackType: "Success"
            })
            setNotification(data)
            

          } else {

            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Responce Failed",
              snackType: "Error"
            })
          }
        }).catch((err) => {


          setSnacBar({
            ...snacBar,
            snacStatus: true,
            message: "Responce Failed",
            snackType: "Error"
          })
        })
    } else {
      // setLoading(false)
      setSnacBar({
        ...snacBar,
        snacStatus: true,
        message: "Please Enter values to search",
        snackType: "warning"
      })

    }
  }
  const { setLoading, loading } = useGlobalContext();
  const handleSearch = () => {
    setLoading(true)
    if (form.startDate && form.endDate ) {

      const data = {
        startDate: form.startDate,
        endDate: form.endDate,
        skip: 0,
        limit: 25
      }

      PostData("/api/getNotificationData", data)
        .then((data) => {
          setLoading(false)
          if (data.status == true) {
            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Successfully get result",
              snackType: "Success"
            })
            
            console.log(data.data)
            setNotification(data)
            console.log(notifications)
          } else {
            setLoading(false)
            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Response Failed 1",
              snackType: "Error"
            })
          }
        }).catch((err) => {
          setLoading(false)

          setSnacBar({
            ...snacBar,
            snacStatus: true,
            message: "Response Failed",
            snackType: "Error"
          })
        })
    } else {
      setLoading(false)
      setSnacBar({
        ...snacBar,
        snacStatus: true,
        message: "Please Enter values to search",
        snackType: "warning"
      })

    }
  }
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }
  // const notify = notifications?.data?.count
  // console.log(notify)
//   useEffect(() => {
//     fetchData("/api/getNotificationData").then((success) => {
//         if(!success.status && success.message === "jwt expired"){
//             // setUser({})
//             navigate('/')
//         }else{

//             const notificationget = JSON.parse(success);
//             setNotification(notificationget);
//         }
//     })
// }, [])
  return (
    <>
    {!loading ?
    <div className="flex justify-center">
      <div className='flex flex-col  w-9/12'>
        <div className='flex justify-start mt-20'>
          <div className="flex items-center">
            <div >
              <label> Start Date</label>
              <input value={form?.startDate} onChange={handleChange} name="startDate" type="date" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date start" />
            </div>
            <span className="mx-4 mt-4 text-gray-500">to</span>
            <div >
              <label>End Date</label>
              <input name="endDate" value={form?.endDate} type="date" onChange={handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date end" />
            </div>
            <div className='mt-6 ml-4'>
              <button
              onClick={handleSearch}
                className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
              >
                Search
              </button>
            </div>
          </div>

        </div>

        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-20">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Date & Time
              </th>
              <th scope="col" className="py-3 px-6">
                Violation
              </th>
            </tr>
          </thead>
          <tbody>
            {
              notifications?.data?.map(n => (
                <tr key={n.id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                  <>
                    <td className='px-6'>{new Date(n?.CreatedOn).toLocaleDateString() + " " +new Date(n?.CreatedOn).toLocaleTimeString()}</td>
                    <td className='px-6'>{n.Violation.Main}<sub>{n.Violation.Sub}</sub></td>
                    

                  </>
                </tr>
              ))
            }
          </tbody>
        </table>
        <Pagination handlePageChange={handlsePageChange} total={notifications?.totalCount} page={Math.ceil(notifications?.totalCount / 25)} />
      </div>
      {snacBar?.snacStatus &&

      <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar} />
      }
    </div>
    : <Loader />}
    </>)
}

export default Notifications